<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="item ? 'Sửa dữ liệu' : 'Thêm dữ liệu'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          v-for="field in fields"
          :key="field.key"
          :lg="24"
          :span="24"
        >
          <el-form-item
            :prop="field.key"
            :label="field.name || field.label"
          >
            <el-input
              v-if="[fileType.TEXT, fileType.TEXTAREA].includes(field.type)"
              v-model="form[field.key]"
              :type="field.type"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="Nhập thông tin"
            />
            <el-input-number
              v-if="[fileType.NUMBER].includes(field.type)"
              v-model="form[field.key]"
              :type="field.type"
              placeholder="Nhập thông tin"
              :min="field.form.min"
              :max="field.form.max"
            />
            <el-date-picker
              v-else-if="
                [fileType.DATE, fileType.DATETIME].includes(field.type)
              "
              v-model="form[field.key]"
              placeholder="Chọn ngày"
              class="w-100"
              :format="field.format | getElementDateFormat"
              :type="field.type"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex"
import {
  arrayToObject,
  notification,
  convertPayloadData,
} from "@/utils/common";
import commonServices from "@/services/common";
import constants from "@/config/constants";

export default {
  name: "DataFormPopup",
  props: {
    category: Object,
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      form: {},
      callingAPI: false,
      options: {},
      fileType: constants.FIELD_TYPE,
    };
  },
  computed: {
    fields() {
      const result = this.category?.extra?.fields || [];
      return result;
    },
    isCreate() {
      return !this.item || !this.item.id;
    },
    payloadData() {
      const data = this.isCreate
        ? {
            extra: {
              ...this.form,
            },
          }
        : {
            ...this.item,
            extra: {
              ...this.item.extra,
              ...this.form,
            },
          };
      return convertPayloadData(this.category.extra.key, data);
    },
    rules() {
      const result = {};
      for (let i = 0; i < this.fields.length; i++) {
        const field = this.fields[i];
        const itemRules = [];
        if (field.form.required) {
          itemRules.push({
            required: true,
            message: `${field.name} là trường bắt buộc.`,
            trigger: ["blur", "change"],
          });
        }
        if (field.form.pattern) {
          const dataType = constants.DATA_TYPES.find(
            (t) => t.key === field.form.pattern
          );
          if (dataType) {
            itemRules.push({
              pattern: dataType.pattern,
              message: `${field.name} không hợp lệ.`,
              trigger: ["blur", "change"],
            });
          }
        }
        if (itemRules.length > 0) {
          result[field.key] = itemRules;
        }
      }
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    ...mapActions("category", ["setAllCategories"]),
    loadFormData() {
      if (this.item) {
        this.form = JSON.parse(JSON.stringify(this.item.extra));
      } else {
        this.form = arrayToObject(this.fields);
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices[!this.isCreate ? "update" : "create"](
            "categories",
            this.payloadData
          )
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                "danh mục"
              );
              this.setAllCategories();
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                "danh mục"
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
